import { UseQueryOptions, useQuery } from '@tanstack/react-query'

import { getAssignableAssignees } from 'services/results'
import { ResultsQueryKeys } from 'services/results/queryKeys'
import type { GetAssignableAssigneesResponse } from 'services/results/types'
import { ApiErrorResponse } from 'services/types'

export const useGetAssignableAssignees = (
  resultId: string,
  options?: Omit<UseQueryOptions<GetAssignableAssigneesResponse, ApiErrorResponse>, 'queryKey'>
) => {
  return useQuery<GetAssignableAssigneesResponse, ApiErrorResponse>({
    queryKey: ResultsQueryKeys.AssignableAssignees(resultId),
    queryFn: ({ signal }) => getAssignableAssignees(resultId, { signal }),
    enabled: !!resultId,
    ...options
  })
}
